import store from '@/store'

export default [
  {
    path: '/customer-profiles',
    name: 'customer-profile',
    meta: { requireAuth: true },
    component: () => import('@/pages/customer-profile/index.vue')
  },
  {
    path: '/customer-profiles/create',
    name: 'customer-profile-create',
    meta: { requireAuth: true },
    component: () => import('@/pages/customer-profile/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('customerProfile/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/customer-profiles/:id',
    name: 'customer-profile-edit',
    meta: { requireAuth: true },
    component: () => import('@/pages/customer-profile/edit.vue'),
    props: route => ({ customerProfile: route.params.customerProfile }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('customerProfile/dataBeforeCreate')
      let response = await store.dispatch('customerProfile/find', to.params.id)
      let {
        customer_type,
        customer_zone,
        service_type,
        ...resource
      } = response.data
      to.params.customerProfile = resource
      next()
    }
  }
]
